  import {
    FETCH_PROJECTS,
    RESET_PROJECTS,
    FETCH_ALL_PROJECTS,
  } from './../../mutation-types';

  export default {
    [FETCH_PROJECTS](state, { projects, pagination }) {
      state.items = projects;
      state.pagination = pagination;
    },

    [RESET_PROJECTS](state) {
      state.all = [];
      state.items = [];
      state.pagination = {};
    },

    [FETCH_ALL_PROJECTS](state, projects) {
      state.all = projects;
    },
  };



// WEBPACK FOOTER //
// ./src/app/store/modules/project/mutations.js